export default class hr {
    static translations = {
        labels: {
            logout: 'Odjava',
            profile: 'Profil',
            yourData: 'Vaši podaci',
            rowsPerPage: 'Redaka po stranici:',
            totalRecords: 'Ukupno zapisa:',
            all: 'Svi',
            noResults: 'Nema rezultata.',
            of: 'od',
            from: 'od',
            to: 'do',
            uploadInProgress: 'Slanje u tijeku.',
            new: 'Novo',
            dragdropMultiple: 'Povucite datoteke ovdje',
            dragdropSingle: 'Povucite datoteku ovdje',
            page: 'Stranica',
            additionalFilters: 'Dodatni filteri',
            yes: 'Da'
        },
        modules: {
            login: 'Prijava',
            dashboard: 'Kontrolna ploča',
            profile: 'Moj profil',
            userAccounts: 'Korisnički računi',
            newUserAccount: 'Novi korisnički račun',
            showcase: 'Showcase',
            projects: 'Projekti',
            gantogram: 'Gantogram'
        },
        fields: {
            search: 'Pretraga',
            firstName: 'Ime',
            lastName: 'Prezime',
            email: 'E-mail',
            password: 'Lozinka',
            rememberMe: 'Zapamti prijavu',
            passwordChange: 'Promjena lozinke',
            oldPassword: 'Stara lozinka',
            newPassword: 'Nova lozinka',
            newPasswordConfirmation: 'Ponovljena nova lozinka',
            active: 'Aktivno',
            role: 'Uloga',
            selectHeaders: 'Odaberi stupce',
            name: 'Naziv',
            user: 'Korisnik',
            dateCreated: 'Datum kreiranja',
            deadline: 'Rok',
            amount: 'Iznos',
            upload: 'Jedna datoteka',
            uploadMultiple: 'Više datoteka'
        },
        alerts: {
            deletionQuestion: 'Jeste li sigurni da želite izbrisati ovaj zapis?',
            fileDeletionQuestion: 'Jeste li sigurni da želite izbrisati ovu datoteku?',
            photoDeletionQuestion: 'Jeste li sigurni da želite izbrisati ovu fotografiju?',
            firstNameMissing: 'Niste unijeli ime.',
            lastNameMissing: 'Niste unijeli prezime.',
            emailMissing: 'Niste unijeli e-mail.',
            emailFailFormat: 'Email je neispravan.',
            passwordMissing: 'Niste unijeli lozinku.',
            passwordFailConfirmation: 'Lozinke se ne podudaraju.',
            passwordResetSuccess: 'Nova lozinka poslana je na unesenu e-mail adresu.',
            passwordResetFail: 'Nije pronađen korisnik sa unesenom e-mail adresom.',
            passwordLength: 'Lozinka mora imati minimalno 8 znakova.',
            passwordLetters: 'Lozinka mora imati barem jedno slovo.',
            passwordDigits: 'Lozinka mora imati barem jednu znamenku.',
            passwordOthers: 'Lozinka mora imati barem jedan poseban znak.',
            loginFail: 'Neispravni podaci za prijavu.',
            basicUpdate: 'Promjene spremljene.',
            basicDelete: 'Zapis izbrisan.',
            basicAdd: 'Zapis dodan.',
            basicError: 'Došlo je do greške na poslužitelju.',
            fieldMissing: 'Ovo polje je obavezno',
            deleteError: 'Ovaj zapis ne možete izbrisati.',
            leaveQuestion: 'Jeste li sigurni da želite otići bez spremanja?',
            generatePasswordQuestion: 'Jeste li sigurni da želite generirati novu lozinku ovom korisniku?',
            recordLocked: 'Ovaj zapis je zaključan jer ga uređuje %name%.'
        },
        buttons: {
            backToWebsite: 'Back to website',
            login: 'Prijava',
            logout: 'Odjava',
            profile: 'Profil',
            new: 'Novo',
            save: 'Spremi',
            edit: 'Uredi',
            add: 'Dodaj',
            cancel: 'Odustani',
            yes: 'Da',
            no: 'Ne',
            ok: 'OK',
            delete: 'Briši',
            back: 'Natrag',
            forgottenPassword: 'Zaboravili ste lozinku?',
            filter: 'Filtriraj',
            cancelFilter: 'Poništi filtriranje',
            all: 'Sve',
            generateNewPassword: 'Pošalji novu lozinku',
            send: 'Pošalji',
            partial: 'Djelomično',
            previousMonth: 'Prethodni mjesec',
            nextMonth: 'Sljedeći mjesec'
        },
        tooltips: {
            edit: 'Uredi',
            delete: 'Briši',
            filter: 'Filter',
            logout: 'Logout',
            openInNewTab: 'Otvori u novom tabu',
            excel: 'Excel export',
            resetFilters: 'Poništi filtere',
            additionalFilters: 'Dodatni filteri',
            selectHeaders: 'Odaberi stupce'
        },
        texts: {
            passwordReset: `Ako ste zaboravili lozinku ovdje možete zatražiti slanje e-maila sa novom lozinkom.`
        }
    };
}
